import { Route, useLocation } from 'react-router';
import ScreenHeader from '@legacy/components/layout/ScreenHeader';
import { ResourcePlanner } from '@legacy/screens/ResourcePlanner';
import { SearchProjects } from '@legacy/screens/SearchProjects';
import { MoveHours } from '@legacy/screens/MoveHours';
import { designSevenPagePath } from '@legacy/designSevenPagePath';
import { SearchForTaskDialog } from '@legacy/screens/ResourcePlanner/screens/SearchForTaskDialog';
import { SearchForResourceDialog } from '@legacy/screens/ResourcePlanner/screens/SearchForResourceDialog';
import { SearchForProjectDialog } from '@legacy/screens/ResourcePlanner/screens/SearchForProjectDialog';

import { PageRoute } from '../PageRoute';

export const ProjectsRouter = () => {
  const location = useLocation();

  return [
    <Route
      key="legacy-resource-planner"
      path={designSevenPagePath.projects.resourcePlanner}
      element={
        <>
          <ScreenHeader />
          <PageRoute
            pageTitle="ResourcePlanner"
            pageId="c210b1c5-f3df-44d8-b17c-43c10a504c0d"
            pageIdentifier="NewResourcePlanner"
          >
            <ResourcePlanner />
          </PageRoute>
        </>
      }
    >
      {location.pathname.startsWith('/projects/resource-planner/') && (
        <>
          <Route
            path="assign-resource/:id"
            element={<SearchForProjectDialog />}
          />
          <Route
            path="assign-resource/:id/:projectId/tasks"
            element={<SearchForTaskDialog />}
          />
          <Route path="assign-task/:id" element={<SearchForResourceDialog />} />
        </>
      )}
    </Route>,

    <Route
      key="legacy-search-projects"
      path={designSevenPagePath.projects.searchProjects}
      element={
        <>
          <ScreenHeader />
          <PageRoute
            pageTitle="SearchProjects"
            pageId="c3e04a88-0a00-487f-9e59-9d101a96462f"
            pageIdentifier="DesignSevenSearchProject"
            fallbackUrl="/projectManagement/Search/SearchProjects"
            key="SearchProjectsRouteKey"
          >
            <SearchProjects />
          </PageRoute>
        </>
      }
    />,

    <Route
      key="legacy-move-hours"
      path={designSevenPagePath.projects.moveHours}
      element={
        <>
          <ScreenHeader />
          <PageRoute
            pageTitle="MoveHours"
            pageId="7af9b8f1-dc98-4bc7-a1a4-9081451b0d1b"
            pageIdentifier="DesignSevenMoveHours"
            fallbackUrl="/projectManagement/Adjustment/RedistributionOfTime"
            key="MoveHoursRouteKey"
          >
            <MoveHours />
          </PageRoute>
        </>
      }
    />,
  ];
};
